import * as fromSearch from './search.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'search';

export interface SearchState {
  searchResults: fromSearch.SearchState;
}

export const reducers: ActionReducerMap<SearchState> = {
  searchResults: fromSearch.SearchResultsReducer,
};

export const getSearchtate = createFeatureSelector<SearchState>(featureKey);

export const metaReducers: MetaReducer<SearchState>[] = !environment.production ? [] : [];
